import { render, staticRenderFns } from "./Weigher.vue?vue&type=template&id=13e94dc0"
import script from "./Weigher.vue?vue&type=script&lang=js"
export * from "./Weigher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports